import { ILeftMenuActions } from "Actions";
import {
  CLOSE_MENU,
  CLOSE_SECONDARY_MENU,
  OPEN_MENU,
  OPEN_SECONDARY_MENU,
  SET_ACTIVE,
  SET_SUB_ACTIVE,
  TOGGLE_HOVER,
  TOGGLE_MENU,
  TOGGLE_SECONDARY_MENU,
  TOGGLE_FLYOUT_PINNED,
  TOGGLE_SECONDARY_AVAILABLE,
} from "Actions/LeftMenuActions/leftMenuActionTypes";
import { Reducer } from "redux";

export interface IleftMenuReducer {
  isMenuOpen: boolean;
  key: string;
  subKey: string;
  isSecondaryOpen: boolean;
  debouncedIsHover: boolean;
  isFlyoutPinned: boolean;
  isSecondaryAvailable: boolean;
}

export const defaultLeftMenuState = {
  isMenuOpen: true,
  key: "",
  subKey: "",
  isSecondaryOpen: false,
  debouncedIsHover: false,
  isFlyoutPinned: true,
  isSecondaryAvailable: false,
};

export const leftMenuReducer: Reducer<IleftMenuReducer, ILeftMenuActions> = (
  state = defaultLeftMenuState,
  action
) => {
  switch (action.type) {
    case OPEN_MENU: {
      return {
        ...state,
        isMenuOpen: true,
      };
    }
    case CLOSE_MENU: {
      return {
        ...state,
        isMenuOpen: false,
      };
    }
    case TOGGLE_MENU: {
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen,
      };
    }
    case TOGGLE_HOVER: {
      return {
        ...state,
        debouncedIsHover: !state.debouncedIsHover,
      };
    }
    case TOGGLE_SECONDARY_MENU: {
      return {
        ...state,
        isSecondaryOpen: !state.isSecondaryOpen,
      };
    }
    case OPEN_SECONDARY_MENU: {
      return {
        ...state,
        isSecondaryOpen: true,
      };
    }
    case CLOSE_SECONDARY_MENU: {
      return {
        ...state,
        isSecondaryOpen: false,
      };
    }
    case SET_ACTIVE: {
      const { key } = action.payload;
      return {
        ...state,
        key,
      };
    }
    case SET_SUB_ACTIVE: {
      const { key: subKey } = action.payload;
      return {
        ...state,
        subKey,
      };
    }
    case TOGGLE_FLYOUT_PINNED: {
      return {
        ...state,
        isFlyoutPinned: !state.isFlyoutPinned,
      };
    }
    case TOGGLE_SECONDARY_AVAILABLE: {
      return {
        ...state,
        isSecondaryAvailable: !state.isSecondaryAvailable,
      };
    }
  }
  return state;
};
